// 2026-05-26 - FormuLearning - Axios 인스턴스 (인터셉터, 토큰 갱신)
// 2026-11-03 수정 - 이슈 #114: viewer 쓰기·실행 요청 차단 안전망(`lib/readOnly` `blockedForViewer`).
// 파일 위치: frontend/src/api/client.ts

import axios from 'axios'
import { ReadOnlyError, blockedForViewer } from '../lib/readOnly'

const client = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
})

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // 이슈 #114 안전망 — viewer 의 쓰기·실행 요청은 보내지 않는다(autosave·자동 호출이 403 을 쏟지 않게).
  if (blockedForViewer(config.method, config.url)) {
    return Promise.reject(new ReadOnlyError())
  }
  return config
})

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true
      try {
        const { data } = await axios.post('/api/v1/auth/refresh', null, { withCredentials: true })
        const newToken = data.data.access_token
        localStorage.setItem('access_token', newToken)
        original.headers.Authorization = `Bearer ${newToken}`
        return client(original)
      } catch {
        localStorage.removeItem('access_token')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

export default client
